import { MemoryStorage } from './memoryStorageClass';
import { Storage } from './Storage';

export const memoryStorage = new Storage(new MemoryStorage());
